<template>
  <span class="produto-restricao produto-consumo" :class="{'produto-consumo-sacola': variant === 'sacola'}" v-if="filter.includes(consumo)">
    {{ consumo | tipo_consumo }}
  </span>
</template>

<script>
export default {
  name: "ProdutoConsumo",
  props: ['consumo', 'tipo_pedido', 'variant'],
  data() {
    return {
      filter: this.tipo_pedido === '3' ? ['2','3','5'] : ['2','3','4','6']
    }
  },

  filters: {
    tipo_consumo(tipo) {
      switch (tipo) {
        case '2':
          return 'Retirada';
        case '3':
          return 'Entrega';
        case '4':
          return 'No local';
        case '5':
          return 'Retirada + Entrega';
        case '6':
          return 'Retirada + Local';
      }
    }
  }
}
</script>

<style scoped>
.produto-restricao {
  display: inline-block;
  max-width: 100%;
  padding: 4px 6px;
  overflow: hidden;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 600;
  line-height: 1.2;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.produto-consumo {
  color: #40556b;
  background-color: #e9eff4;
}

.produto-consumo-sacola {
  color: #30475b;
  background-color: #d4e0e9;
}
</style>
